import { Component, Inject, Input, OnDestroy, OnInit, Optional, Pipe, PipeTransform } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AutenticacionService } from '../autenticacion.service';
import { GoogleAnalyticsService } from '../google-analytics.service';
import { FacebookPixelService } from '../facebook-pixel.service';
import { SharedService } from '../shared.service';

@Component({
  selector: 'app-producto-item',
  templateUrl: './producto-item.component.html',
  styleUrls: ['./producto-item.component.scss']
})
export class ProductoItemComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  @Input() item: any;
  @Input() sesion: any;
  @Input() mensaje: any;
  @Input() mensajeFavorito: any;
  @Input() relacionado: any;
  @Input() itemcarousel: any;
  @Input() combo: any;
  @Input() home: any;
  @Input() insumo: any;
  config: any;
  public iva_usuario: string = '';
  public search_term = '';
  constructor(
    private data: SharedService,
    private auth: AutenticacionService,
    private route: ActivatedRoute,
    private googleAnalyticsService: GoogleAnalyticsService,
    private facebookPixelService: FacebookPixelService,
    @Optional() @Inject('serverUrl') protected serverUrl: string
  ) {}
  private replaceHash($entrada: string) {
    return $entrada ? $entrada.replace(new RegExp('/'), '~') : $entrada;
  }
  arrayCants: any[] = [];
  ngOnInit() {
    this.route.params.pipe(takeUntil(this.destroy$)).subscribe((params: any) => {
      const path = typeof window !== typeof undefined ? window.location.href : (environment.APP_WEB_BASE + this.serverUrl?.slice(1));
      if (path.indexOf('/busqueda/') !== -1) {
        if (!params['id2'] && !params['padre']) {
          this.search_term = params['id'];
        } else {
          this.search_term = '';
        }
      } else {
        this.search_term = '';
      }
    });

    const categoria = (this.item.categorias && this.item.categorias.length > 0) ? this.item.categorias[0] : null;
    const padre = categoria ? (categoria.padre ? categoria.padre.nombre.split(' ').join('-') : 'Categoria') : 'Categoria';
    const hijo = categoria ? categoria.nombre.split(' ').join('-') : 'Subcategoria';
    this.item.fullLink = '/' + this.replaceHash(padre) + '/' + this.replaceHash(hijo) + '/' + this.replaceHash(this.item.titulo) + '/' + this.replaceHash(this.item.id);
    this.item.comprado    = false;
    this.item.favorito = false;
    if (!this.insumo) {
      this.item.cantidad    = this.item.cantSugerida ? parseInt(this.item.cantSugerida) : 1;
      if (this.item.cantPack !== '1') {
        this.item.cantidad  = this.item.cantPack ? parseInt(this.item.cantPack) : 1;
        for (let i = 0; i < 20; i++) {
          this.arrayCants[i] = this.item.cantidad * (i + 1);
        }
        for (let i = 0; i < 50; i++) {
          this.arrayCants[i + 20] = this.item.cantidad * (i + 3) * 10;
        }
      }
    } else {
      this.arrayCants[0] = this.item.cantidad;
    }
    this.item.oferta      = this.item.oferta == '1' ? true : false;
    this.data.aplicarPrecioVisibleProducto(this.item);
    this.item.imperdible  = this.item.oferta == false ? (this.item.novedad == '1' ? true : false) : false;
    this.item.precio_mostrado = this.item.precio ? this.item.precio.toString().replace(',', '.') : '0';
    this.item.precio_base = this.item.precioLista || this.item.precioListaBase;
    if (this.item.precio_base > 0 && this.item.precio_base > this.item.precio) {
      this.item.descuento = this.calcularDescuento(this.item.precio_base, this.item.precio_mostrado);
      // Decidimos si mostrar el descuento a partir numero mayor o igual a 5% OFF
      if (this.item.descuento >= 5) {
        this.item.show_descuento = true;
      } else {
        this.item.show_descuento = false;
      }
    } else {
      this.item.descuento = undefined;
      this.item.show_descuento = false;
    }
    this.data.lista.forEach((articulo_carrito) => {
      if (articulo_carrito.id === this.item.id) {
        this.item.comprado = true;
      }
    });
    if (this.data.listaFavoritos.some((articulo_favorito) => articulo_favorito.id_producto === this.item.id )) {
      this.item.favorito = true;
    }
    this.data.currentUser.pipe(takeUntil(this.destroy$)).subscribe(($user: any) => {
      if ($user && $user['c'] == '1') {
        this.iva_usuario = '';
      } else {
        if ($user) {
          switch ($user['codCategoriaIva']) {
            case 'CF': this.iva_usuario = 'UNIT I.V.A. incluido'; break;
            case 'INR': this.iva_usuario = 'UNIT I.V.A. incluido'; break;
            case 'RS': this.iva_usuario = 'UNIT I.V.A. incluido'; break;
            case 'RSS': this.iva_usuario = 'UNIT I.V.A. incluido'; break;
            case 'RI': this.iva_usuario = 'UNIT + I.V.A.'; break;
            case 'EX': this.iva_usuario = 'UNIT I.V.A. incluido'; break;
            case 'PCE': this.iva_usuario = 'UNIT I.V.A. incluido'; break;
            case 'PCS': this.iva_usuario = 'UNIT I.V.A. incluido'; break;
            case 'EXE': this.iva_usuario = 'UNIT Final'; break;
            case 'SNC': this.iva_usuario = 'UNIT I.V.A. incluido'; break;
            default: this.iva_usuario = 'UNIT + I.V.A.';
          }
        }
      }
    });

    // subscribing to config change
    this.data.currentConfig.pipe(takeUntil(this.destroy$)).subscribe(
      (configuracion: any) => {
        this.config = configuracion;
      },
    );
  }

  calcularDescuento(precioBase: number, precioMostrado: number): number {

    const cleanPrecioBase = Number(precioBase.toString().replace(/[^0-9.-]+/g,""));
    const cleanPrecioMostrado = Number(precioMostrado.toString().replace(/[^0-9.-]+/g,""));

    return Math.floor((cleanPrecioBase - cleanPrecioMostrado) / cleanPrecioBase * 100);
  }

  ngOnDestroy() {
    this.destroy$.next();
  }

  enterCheck() {
    this.newMessage(this.item);
  }
  newMessage(msg: any) {
    if (this.sesion === true) {
      if (msg.cantidad) {
        if ((+msg.cantidad % +msg.cantPack === 0 && +msg.cantidad > +msg.cantMinima) || (+msg.cantMinima === +msg.cantidad)) {
          const body = new URLSearchParams();
          body.set('id_producto', msg.id);
          body.set('cantidad', msg.cantidad);
          this.auth.post('carrito/agregar_item', body)
          .then(($response) => {
            if (environment.production) {
              this.googleAnalyticsService.addToCart({ sku: msg.codInterno, descripcion: msg.titulo, categoria: msg.categorias ? msg.categorias[0]?.nombre : undefined, precio: msg.precio, cantidad: msg.cantidad });
              this.facebookPixelService.addToCart({ sku: msg.codInterno, descripcion: msg.titulo, categoria: msg.categorias ? msg.categorias[0]?.nombre : undefined, precio: msg.precio, cantidad: msg.cantidad });
            }
            this.data.log('response carritoagregaritem producto-item', $response);

            const response = this.data.addMessage(msg);
            if (response.value) {
              this.mensaje.next(response.text);
            }
          })
          .catch(($error) => {
            this.data.log('error carritoagregaritem producto-item', $error);
          });
        } else {
          msg['incompleto'] = true;
        }
      }
    } else {
      this.data.toggleLoginModal();
    }
  }
  removeMessage(msg: any) {
    if (this.sesion === true) {
      const body = new URLSearchParams();
      body.set('id_producto', msg.id);
      this.auth.post('carrito/eliminar_item', body)
      .then(($response) => {
        if (environment.production) {
          this.googleAnalyticsService.removeFromCart({ sku: msg.codInterno, descripcion: msg.titulo, categoria: msg.categorias ? msg.categorias[0]?.nombre : undefined, precio: msg.precio, cantidad: msg.cantidad });
          this.data.log('response carritoeliminaritem compra', $response);
        }
        this.data.removeMessage(msg);
        msg.comprado = false;
      })
      .catch(($error) => {
        this.data.log('error carritoeliminaritem compra', $error);
      });
    } else {
      this.data.toggleLoginModal();
    }
  }

  public revisarCantidad(e: any) {
    if (e.target && parseInt(e.target.value) < parseInt(e.target.min)) {
      e.target.value = e.target.min;
    }
  }

  formatMoney(n: any, c: any = undefined, d: any = undefined, t: any = undefined) {
    let s;
    let i;
    let j;
    c = isNaN(c = Math.abs(c)) ? 2 : c,
    d = d == undefined ? ',' : d,
    t = t == undefined ? '.' : t,
    s = n < 0 ? '-' : '',
    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
    j = (j = i.length) > 3 ? j % 3 : 0;

    return s + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(n - +i).toFixed(c).slice(2) : '');
  }

  async toggleFavorito(item: any) {
    if (this.sesion === true) {
      const body = new URLSearchParams();
      body.set('id_producto', item.id);
      if (item.favorito) {
        try {
          const responseDelete = await this.auth.post('cliente/productos_favoritos/eliminar', body);
          if (responseDelete && responseDelete.status) {
            this.item.favorito = false;
            this.data.setProductosFavoritos(this.data.listaFavoritos.filter((f) => f.id_producto !== item.id));
            this.mensajeFavorito.next("Producto eliminado de la lista de favoritos!");
          }
        } catch (error) {
          this.mensajeFavorito.next("Error al eliminar producto de la lista de favoritos");
        }
      } else {
        try {
          const responseAdd = await this.auth.post('cliente/productos_favoritos/insertar', body);
          if (responseAdd && responseAdd.status) {
            this.item.favorito = true;
            this.data.setProductosFavoritos([...this.data.listaFavoritos, { id_producto: item.id, producto: { ...item } }]);
            this.mensajeFavorito.next("Producto agregado a la lista de favoritos!");
          }
        } catch (error) {
          this.mensajeFavorito.next("Error al agregar producto a la lista de favoritos");
        }
      }
    } else {
      this.data.toggleLoginModal();
    }
  }
}

@Pipe({
  name: 'highlight',
  pure: true // true makes it pure and false makes it impure
})
export class HighlightSearchPipe implements PipeTransform {

  transform(text: string, search: any): string {
    if (search && text) {
      let pattern = search.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
      pattern = pattern.split(' ').filter((t: any) => {
        return t.length > 0;
      }).join('|');
      const regex = new RegExp(pattern, 'gi');

      return text.replace(regex, (match) => `<span class="search-highlight">${match}</span>`);
    } else {
      return text;
    }
  }

}
